module.exports = __webpack_public_path__ + "img/whats-new-2_jp.fb25712.jpg";